import { FontWeights, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { UlmContainer } from "@components/ulm/ulm-container";
import EmailIcon from "@assets/icons/email_60px.svg?react";
import { ContactSupport } from "@components/ulm/contact-support";
import { PageTitle } from "@components/common/page-title";
import { PageSubtitle } from "@components/common/page-subtitle";

interface Props {
  /** The recipient's email address to which the password reset link has been sent. */
  email: string;
}

/**
 * A confirmation message explaining to the user that a password reset link
 * has been sent to the provided email address.
 */
export function PasswordRecoverySuccess({ email }: Props): JSX.Element {
  return (
    <UlmContainer>
      <PageTitle>Check your email</PageTitle>
      <PageSubtitle>
        <var>{email}</var>
      </PageSubtitle>

      <Stack
        sx={{
          width: "106px",
          height: "106px",
          bgcolor: "surfaces.secondary",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          marginTop: "25px",
        }}
      >
        <EmailIcon />
      </Stack>

      <Text
        variant="bodyL"
        component="p"
        sx={{
          color: "text.secondary",
          fontWeight: FontWeights.SemiBold,
          marginTop: "25px",
        }}
      >
        We've sent a reset link to your email address.
      </Text>

      <Text
        variant="bodyL"
        component="p"
        sx={{
          color: "text.secondary",
          marginTop: "25px",
          textAlign: "center",
        }}
      >
        If you don't receive the email within a few moments, please check your
        spam folder or contact <ContactSupport />
      </Text>
    </UlmContainer>
  );
}
